const el = {
    welcome: "Καλωσόρισες",
    Login: "Σύνδεση",
    Logout: "Αποσύνδεση",
    anonymous_user: "[ανώνυμε] χρήστη",
    anonymous_message: "Πληκτρολογήστε το ανώνυμο μήνυμά σας...",
    user_message: "Πληκτρολογήστε το μήνυμά σας",
    send: "Αποστολή",
    messages: "Μηνύματα",
    profile: "Προφίλ",
    chat: "Συνομιλία",
    settings: "Ρυθμίσεις",
    language: "Γλώσσα",
    switch_language: "Αλλαγή γλώσσας",
    switch_to_english: "Αλλαγή σε Αγγλικά",
    switch_to_greek: "Αλλαγή σε Ελληνικά",
    error: "Παρουσιάστηκε σφάλμα",
    loading: "Φόρτωση...",
    restricted_access: "Περιορισμένη Πρόσβαση",
    not_found: "Η σελίδα δεν βρέθηκε",
    visit_home_page: "Μετάβαση στην αρχική σελίδα",
    go_back: "Πίσω",
    under_construction: "Αυτός ο ιστότοπος βρίσκεται υπό κατασκευή.",
    welcome_anonymous_world: "Καλώς ήρθατε στον ανώνυμο κόσμο!",
    enter: "Μεταβείτε",
    register: "Εγγραφή",
    register_success: "Η εγγραφή ήταν επιτυχής, μπορείτε τώρα να συνδεθείτε...",
    login_success: "Η σύνδεση ήταν επιτυχής, ανακατεύθυνση στη συνομιλία...",
    go_incognito: "Μπείτε ανώνυμα",
    back_to_chat: "Επιστροφή στη συνομιλία",
    this_website_under_construction: "Αυτή η σελίδα βρίσκεται υπό κατασκευή από τον Γιώργο Μωυσιάδη.",
    log_in: "Συνδεθείτε",
    log_out: "Αποσύνδεση",
    sign_up: "Εγγραφείτε",
    signup:'Εγγραφή',
    anonymous:"ανώνυμος χρήστης",
    wrote:"έγραψε",
    join_chat: "Συμμετοχή στη συνομιλία",
    no_messages_found: "Δεν βρέθηκαν μηνύματα.",
    content_registered: 'Το περιεχόμενο είναι διαθέσιμο μόνο σε εγγεγραμμένους χρήστες, όχι σε ανώνυμους χρήστες!',
    more_feautures: 'Αν θέλετε να αποκτήσετε πρόσβαση σε περισσότερες λειτουργίες αυτού του ιστότοπου, παρακαλώ ',
    create_an_account: 'δημιουργήστε έναν λογαριασμό.',
    add_email_fullname: 'Προσθέστε email και ονοματεπώνυμο (προαιρετικά)',
    password_recovery: 'για την ανάκτηση κωδικού πρόσβασης',
    email_optional: 'Το email είναι προαιρετικό, χρησιμοποιείται για την ανάκτηση κωδικού πρόσβασης',
    view_username_password: 'Προβολή ονόματος χρήστη και κωδικού πρόσβασης',
    username: 'Όνομα χρήστη',
    password: 'Κωδικός πρόσβασης',
    tryingtosignin: 'Προσπάθεια σύνδεσης...',
    tryingtosignup: 'Προσπάθεια εγγραφής...',
    forgot_password: 'Ξεχάσατε τον κωδικό πρόσβασης;',
    sorry_still_working: 'Λυπάμαι, ακόμα δουλεύω πάνω σε αυτό :(',
    check_username_password: 'Ελέγξτε το όνομα χρήστη ή τον κωδικό πρόσβασης και δοκιμάστε ξανά.',
    fetching_user: "Ανάκτηση χρήστη...",
    incognito_mode_detected: "Εντοπίστηκε ανώνυμη λειτουργία.",
    no_token_found: "Δεν βρέθηκε διακριτικό, ο χρήστης ορίζεται σε null.",
    sending_request_to_users_me: "Αποστολή αιτήματος στο /users/me...",
    user_fetched_successfully: "Ο χρήστης ανακτήθηκε με επιτυχία:",
    error_fetching_user: "Σφάλμα κατά την ανάκτηση χρήστη, αποσύνδεση:",
    login_unsuccessful: "Η σύνδεση δεν ήταν επιτυχής. Παρακαλώ δοκιμάστε ξανά.",
    login_timeout: "Το αίτημα σύνδεσης έληξε. Παρακαλώ δοκιμάστε ξανά.",
    login_failed: "Η σύνδεση απέτυχε:",
    registration_successful: "Η εγγραφή ήταν επιτυχής:",
    registration_error: "Σφάλμα κατά την εγγραφή:",
    login: "Σύνδεση",
    logout: "Αποσύνδεση",
    server_error: "Σφάλμα διακομιστή",
    logged_out: "Έχετε αποσυνδεθεί. Τα λέμε σύντομα!",
    changed_mind: "Αλλάξατε γνώμη;",
    go_to_login_page: "Μετάβαση στη σελίδα σύνδεσης",
    view_messages: "Προβολή μηνυμάτων",
    blank_message: "Το μήνυμα είναι κενό",
    send_message: "Στείλτε το μήνυμά σας",
    fill_username_password: 'Συμπλήρωσε όνομα χρήστη και κωδικό πρόσβασης',
    fill_username: 'Συμπλήρωσε όνομα χρήστη',
    fill_password: 'Συμπλήρωσε κωδικό πρόσβασης',
    fill_email: 'Συμπλήρωσε email',
    invalid_email: 'Μη έγκυρη μορφή email',
    only_letters_numbers: 'Επιτρέπονται μόνο γράμματα και αριθμοί στο όνομα χρήστη',
    only_letters_in_last_name: 'Επιτρέπονται μόνο γράμματα στο επώνυμο',
    only_letters_in_first_name: 'Επιτρέπονται μόνο γράμματα στο όνομα',
    click_here_login: 'Κάντε κλικ εδώ για να συνδεθείτε',
    click_here_singup: 'Κάντε κλικ εδώ για να εγγραφείτε',
    view_email_fullname: 'Προβολή email και ονοματεπώνυμου',
    view_useranme_password: 'Προβολή ονόματος χρήστη και κωδικού πρόσβασης',
    logged_out_successfully: 'Αποσυνδεθήκατε με επιτυχία!',
    no_email: ' δεν έχει δώσει email ακόμα',
    no_fullname: ' δεν έχει δώσει ονοματεπώνυμο ακόμα',
    fullname: 'Ονοματεπώνυμο',
    switch_language_el: "Switch to Greek / Αλλάξτε στα Ελληνικά",
    switch_language_en: "Αλλάξτε στα Αγγλικά / Switch to English",
    visit_profile_info: 'Επισκεφθείτε το προφίλ',
    enter_chat_with_credentials: 'Mεταβείτε στη συνομιλία με στοιχεία σύνδεσης',
    logout_title:'Αποσυνδεθείτε από τον λογαριασμό σας',
    sign_up_title: 'Δημιουργείστε έναν λογαριασμό',
    sign_in_title: 'Συνδεθείτε στον λογαριασμό σας',
    go_incognito_title: 'Μπορείτε να μπείτε χωρίς να εγγραφείτε',

};

export default el;